import React from "react";
import { useBenefitsTableData } from "./hooks/useBenefitsTableData";
import { Benefits } from "@housebets/housebets-x-package";
import { useIntl } from "react-intl";

export const BenefitsTable: React.FC = () => {
    const {benefitsData} = useBenefitsTableData();
    const {$t} = useIntl();

    return (
        <Benefits
            initActiveTab={0}
            tabs={[
                {
                    id: "Bronze",
                    label: $t({id: "Bronze"}),
                    available: true,
                    whiteName: true,
                    panel: [
                        <>
                            <Benefits.Header level="bronze" label={$t({id: "Bronze"})} title="VIP 0-6" />
                            {benefitsData.bronze.map((item, i) => (
                                <Benefits.Row title={$t({id: String(item.title)})} description={$t({id: String(item.description)})} icon={item.icon} key={i} />
                            ))}
                        </>,
                    ],
                },
                {
                    id: "Silver",
                    label: $t({id: "Silver"}),
                    available: true,
                    whiteName: true,
                    panel: [
                        <>
                            <Benefits.Header level="silver" label={$t({id: "Silver"})} title="VIP 7-11" />
                            {benefitsData.silver.map((item, i) => (
                                <Benefits.Row title={$t({id: String(item.title)})} description={$t({id: String(item.description)})} icon={item.icon} key={i} />
                            ))}
                        </>,
                    ],
                },
                {
                    id: "Gold",
                    label: $t({id: "Gold"}),
                    available: true,
                    whiteName: true,
                    panel: [
                        <>
                            <Benefits.Header level="gold" label={$t({id: "Gold"})} title="VIP 12-16" />
                            {benefitsData.gold.map((item, i) => (
                                <Benefits.Row title={$t({id: String(item.title)})} description={$t({id: String(item.description)})} icon={item.icon} key={i} />
                            ))}
                        </>,
                    ],
                },
                {
                    id: "Platinum",
                    label: $t({id: "Platinum"}),
                    available: true,
                    whiteName: true,
                    panel: [
                        <>
                            <Benefits.Header level="platinum" label={$t({id: "Platinum"})} title="VIP 17-21" />
                            {benefitsData.platinum.map((item, i) => (
                                <Benefits.Row title={$t({id: String(item.title)})} description={$t({id: String(item.description)})} icon={item.icon} key={i} />
                            ))}
                        </>,
                    ],
                },
                {
                    id: "Pearl",
                    label: $t({id: "Pearl"}),
                    available: true,
                    whiteName: true,
                    panel: [
                        <>
                            <Benefits.Header level="pearl" label={$t({id: "Pearl"})} title="VIP 22-26" />
                            {benefitsData.pearl.map((item, i) => (
                                <Benefits.Row title={$t({id: String(item.title)})} description={$t({id: String(item.description)})} icon={item.icon} key={i} />
                            ))}
                        </>,
                    ],
                },
                {
                    id: "Onyx",
                    label: $t({id: "Onyx"}),
                    available: true,
                    whiteName: true,
                    panel: [
                        <>
                            <Benefits.Header level="onyx" label={$t({id: "Onyx"})} title="VIP 27-31" />
                            {benefitsData.onyx.map((item, i) => (
                                <Benefits.Row title={$t({id: String(item.title)})} description={$t({id: String(item.description)})} icon={item.icon} key={i} />
                            ))}
                        </>,
                    ],
                },
                {
                    id: "Diamond",
                    label: $t({id: "Diamond"}),
                    available: true,
                    whiteName: true,
                    panel: [
                        <>
                            <Benefits.Header level="diamond" label={$t({id: "Diamond"})} title="VIP 32-36" />
                            {benefitsData.diamond.map((item, i) => (
                                <Benefits.Row title={$t({id: String(item.title)})} description={$t({id: String(item.description)})} icon={item.icon} key={i} />
                            ))}
                        </>,
                    ],
                },
                {
                    id: "Palladium",
                    label: $t({id: "Palladium"}),
                    whiteName: true,
                    available: false,
                    panel: [
                        <>
                            <Benefits.Header level="palladium" label={$t({id: "Palladium"})} title="VIP 37-41" />
                            {benefitsData.palladium.map((item, i) => (
                                <Benefits.Row title={$t({id: String(item.title)})} description={$t({id: String(item.description)})} icon={item.icon} key={i} />
                            ))}
                        </>,
                    ],
                },
                {
                    id: "Castle",
                    label: $t({id: "Castle"}),
                    whiteName: true,
                    available: false,
                    panel: [
                        <>
                            <Benefits.Header level="castle" label={$t({id: "Castle"})} title="VIP 42-44" />
                            {benefitsData.castle.map((item, i) => (
                                <Benefits.Row title={$t({id: String(item.title)})} description={$t({id: String(item.description)})} icon={item.icon} key={i} />
                            ))}
                        </>,
                    ],
                },
            ]}
        />
    );
};
BenefitsTable.displayName = 'BenefitsTable'